import gql from "graphql-tag";
import PropTypes from "prop-types";
export default {
  query: gql`
    query cardsForClient($clientId: ID!) {
      cards(clientId: $clientId) {
        accountNum
        amountDebit
        amountAvailable
        amountHold
        blockComment
        cardId
        clientName
        contract
        creditLimit
        creditRemainder
        currency
        endDate
        errorCode
        expirationDate
        isActiveInCurrentView
        isValid
        pan
        productName
        seqNumber
        smsPhone
        smsStatus
        startDate
        statusName
        wrongPinCount
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.clientId,
    options: ({ clientId }) => ({
      variables: {
        clientId,
      },
    }),
  },
  propTypes: {
    clientId: PropTypes.string.isRequired,
  },
  isLoaded: (data) => {
    return !!data.cards;
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/cardsForClient.js